module.exports = __webpack_public_path__ + "media/images/application/template/icon--map-marker_smaller-2347bb509af3a1a84600d1fd39781b6b.svg";